export type WorkspaceAgentGuidedVariantImageOutputPhrases = {
  namedFile: string;
  original: string;
  result: string;
  subject: string;
};

export const getWorkspaceAgentGuidedVariantImageOutputPhrases = (
  imageCount: number,
): WorkspaceAgentGuidedVariantImageOutputPhrases => ({
  namedFile: imageCount === 1 ? 'the new file' : 'each new file',
  original: imageCount === 1 ? 'the original' : 'the originals',
  result: imageCount === 1 ? 'the result as a new file' : 'each result as a new file',
  subject: imageCount === 1 ? 'the selected image' : 'each selected image',
});

export type BuildWorkspaceAgentGuidedVariantSkipNonImagesClauseInput = {
  /** e.g. `rounded corners only apply to images` or `remove background only applies to images` */
  featureAppliesToImagesPhrase: string;
  nonImageFilesWording: 'files' | 'non-image files';
  skippedFileCount: number;
  skippedVideoCount: number;
};

export const buildWorkspaceAgentGuidedVariantSkipNonImagesClause = ({
  featureAppliesToImagesPhrase,
  nonImageFilesWording,
  skippedFileCount,
  skippedVideoCount,
}: BuildWorkspaceAgentGuidedVariantSkipNonImagesClauseInput): string => {
  const skippedNonImageCount = skippedFileCount + skippedVideoCount;

  if (skippedNonImageCount === 0) {
    return '';
  }

  return ` Skip videos and other ${nonImageFilesWording} — ${featureAppliesToImagesPhrase}.`;
};

export type BuildWorkspaceAgentGuidedVariantSkipOtherFilesClauseInput = {
  /** e.g. `smart resize only applies to images and videos` */
  appliesToPhrase: string;
  skippedFileCount: number;
};

/** Smart resize and scale or crop keep videos. Other files are still skipped. */
export const buildWorkspaceAgentGuidedVariantSkipOtherFilesClause = ({
  appliesToPhrase,
  skippedFileCount,
}: BuildWorkspaceAgentGuidedVariantSkipOtherFilesClauseInput): string => {
  if (skippedFileCount < 1) {
    return '';
  }

  return ` Skip other files — ${appliesToPhrase}.`;
};
